// extracted by mini-css-extract-plugin
module.exports = {"datatable_grid":"datatable-grid_datatable_grid__2U5S_","datatable_icons":"datatable-grid_datatable_icons___dGW1"};